import SvgRender from 'common/components/general/SvgRender';
import CopyText from 'common/components/general/CopyText';
import copy from 'common/assets/svg/actions/copy.svg';
import PropTypes from 'prop-types';

const InternalPostLink = ({ data }) => {
  return (
    <div className="d-flex align-items-center">
      <span className="pe-1 lh-1">{`/beacon/posts/${data.id}`}</span>
      <CopyText
        text={`/beacon/posts/${data.id}`}
        customText="Copied Details to Clipboard"
        infoTooltip="Copy Contact Details to Clipboard"
      >
        <SvgRender
          className="pointer-events-none text-primary"
          src={copy}
          style={{ heihgt: 10, width: 10 }}
        />
      </CopyText>
    </div>
  );
};

InternalPostLink.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired
};

export default InternalPostLink;
